import * as Dtos from "../../dtos/Tmd.dtos";

export const
    createCollectionTracker: ICollectionInstanceTrackerPageCreateCollectionTrackerActionCreator = (collectionInstanceId) => {
        return {
            type: ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_ADD,
            collectionInstanceId
        }
    },
    editCollectionTracker: ICollectionInstanceTrackerPageEditCollectionTrackerActionCreator = (index, collectionInstanceTracker: Dtos.CollectionInstanceTracker) => {
        return {
            type: ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_EDIT,
            index,
            collectionInstanceTracker
        }
    },
    updateCollectionTracker: ICollectionInstanceTrackerPageUpdateCollectionTrackerActionCreator = (collectionInstanceTracker) => {
        return {
            type: ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_UPDATE,
            collectionInstanceTracker
        }
    },
    resetCollectionTracker: ICollectionInstanceTrackerPageResetCollectionTrackerActionCreator = () => {
        return {
            type: ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_RESET,
        }
    }

export const
    ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_ADD = "ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_ADD",
    ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_EDIT = "ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_EDIT",
    ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_UPDATE = "ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_UPDATE",
    ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_RESET = "ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_RESET"

/* Actions */

export interface ICollectionInstanceTrackerPageCreateCollectionTrackerAction {
    type: "ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_ADD",
    collectionInstanceId: number;
}

export interface ICollectionInstanceTrackerPageEditCollectionTrackerAction {
    type: "ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_EDIT",
    index: number;
    collectionInstanceTracker: Dtos.CollectionInstanceTracker;
}

export interface ICollectionInstanceTrackerPageUpdateCollectionTrackerAction {
    type: "ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_UPDATE",
    collectionInstanceTracker: Dtos.CollectionInstanceTracker;
}

export interface ICollectionInstanceTrackerPageResetCollectionTrackerAction {
    type: "ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_RESET"
}

/* Action Creators */

export interface ICollectionInstanceTrackerPageCreateCollectionTrackerActionCreator {
    (
        collectionInstanceId: number
    ): ICollectionInstanceTrackerPageCreateCollectionTrackerAction;
}

export interface ICollectionInstanceTrackerPageEditCollectionTrackerActionCreator {
    (
        index: number,
        collectionInstanceTracker: Dtos.CollectionInstanceTracker,
    ): ICollectionInstanceTrackerPageEditCollectionTrackerAction;
}

export interface ICollectionInstanceTrackerPageUpdateCollectionTrackerActionCreator {
    (
        collectionInstanceTracker: Dtos.CollectionInstanceTracker,
    ): ICollectionInstanceTrackerPageUpdateCollectionTrackerAction;
}

export interface ICollectionInstanceTrackerPageResetCollectionTrackerActionCreator {
    (): ICollectionInstanceTrackerPageResetCollectionTrackerAction;
}


/* Final Export of actions */
export type CollectionInstanceTrackerPageAction =
    ICollectionInstanceTrackerPageCreateCollectionTrackerAction |
    ICollectionInstanceTrackerPageEditCollectionTrackerAction | 
    ICollectionInstanceTrackerPageUpdateCollectionTrackerAction |
    ICollectionInstanceTrackerPageResetCollectionTrackerAction;
